interface SearchResultCompany {
  companyName: string | null;
  vatNumber: string | null;
  addressLine1: string | null;
  addressLine2?: string | null;
  addressNumber: string | null;
  postalCode: string | null;
  city: string | null;
  country: string | null;
  contact?: {
    email?: string | null;
    web?: string | null;
    telephone?: string | null;
  };
  metadata?: {
    number?: number;
    numberText?: string | null;
    formattedNumber?: string | null;
    startDate?: string | null;
    type?: string | null;
    legalForm?: string | null;
    juridicalSituation?: string | null;
    NACECode?: string | null;
  };
}

interface SearchResultsProps {
  results: SearchResultCompany[];
  show: boolean;
  onSelect: (company: SearchResultCompany) => void;
}

export const CompanySearchResults = ({ results, show, onSelect }: SearchResultsProps) => {
  if (!show || results.length === 0) return null;

  return (
    <div className='absolute top-[52px] left-0 w-full bg-white border border-gray-300 rounded-md shadow-lg z-20'>
      {results.map((company, idx) => (
        <div key={idx} onClick={() => onSelect(company)} className='p-2 hover:bg-gray-200 cursor-pointer'>
          <p className='font-bold'>{company.companyName}</p>
          <p className='text-xs text-gray-500'>
            {company.vatNumber} &middot; {company.addressLine1} {company.addressNumber}
          </p>
        </div>
      ))}
    </div>
  );
};
